const theme = {
    palette: {
        primary: "#30575F",
        dark: "#1e1e24",
        light: "#f8f9fa"
    },
    scale: {
        h1: "2rem",
        h2: "1.5rem"
    }
}

export default theme;